export default "__VITE_ASSET__DpNZhgOR__"